export const AGENT_REWARDS = {
  points: 35,
  value: 35,
};
